// extracted by mini-css-extract-plugin
export var legendIndicator = "_dr-1";
export var legendRight = "_dr-0";